<template>
  <div class="content">
    <div class="top">
      <span :class="type == 1? 'active' : ''" @click="changeType(1)">质量检查</span>
      <span :class="type == 2? 'active' : ''" @click="changeType(2)">安全检查</span>
      <span :class="type == 3? 'active' : ''" @click="changeType(3)">安全红线</span>
    </div>
    <div class="main-box">
      <div class="type12" v-if="type == 1 || type == 2">
        <div class="content-right-4">
          <p>选择问题性质：
            <el-select v-model="priority" clearable placeholder="请选择">
              <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select></p>
          <p>选择责任人：
            <el-select v-model="handleStr" clearable placeholder="请选择">
              <el-option v-for="item in strPerson" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </p>
          <p>选择确认人：
            <el-select v-model="apprStr" clearable placeholder="请选择">
              <el-option v-for="item in strPerson" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </p>
          <p>选择BIM位置：
            <el-select v-model="bimId" clearable placeholder="请选择">
              <el-option v-for="item in bimHouse" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </p>
        </div>
        <p class="p-item">检查内容</p>
        <ul class="ul-item">
          <li>
            <el-input type="textarea" :rows="14" placeholder="请输入内容" v-model="description">
            </el-input>
          </li>
          <li>
            <div style="border-bottom: 1px solid #eee;">
              <div v-for="item in planTree" :key="item.id"
                style="text-align: left;padding:10px;display: flex;align-items: center;justify-content: space-between;font-size: 18px;">
                <div style="display: flex;align-items: center; ">
                  <div class="round_red"></div>
                  <div style="padding: 10px 0px; font-weight: 600;">{{item.name}}</div>
                </div>
                <div style="display: flex;align-items: center;" @click="addPlan(item)">
                  <img style="width: 20px;height:20px;margin-right: 10px;font-size: inherit;" src="../../../assets/image/add.png">添加
                </div>
              </div>
            </div>
            <div>
              <div v-for="item in dataTree" :key="item.id" style="text-align: left;padding:0px 10px;">
                <div style="padding: 10px 0px;font-size: 18px;">{{item.description}}</div>
                <el-checkbox-group v-model="checkedCities" @change="handleChecked" :disabled='isPlan'>
                  <el-checkbox v-for="item1 in item.proQsNapes" :label="item1" :key="item1.id">
                    {{item1.description}}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </li>
        </ul>
        <div class="content-right-3">
          <p style="text-align: left;margin-bottom: 10px">添加现场照片</p>
          <el-upload style="display: flex;padding: 20px 30px;" :action="uploadphotoUrl" list-type="picture-card"
            :headers="uploadHead" :data="uploadphotoData"
            :on-success="handleIconSuccess">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
         <el-button @click="submitFun">提交</el-button>
        <!-- 新增窗口 -->
        <el-dialog title="添加计划" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
          class="add-form" width="400px">
          <div>
            {{checkData.description}}
            <el-checkbox-group v-model="checkedCities1" @change="handleChecked1">
              <el-checkbox v-for="item1 in checkData.proQsNapes" :label="item1" :key="item1.id">
                {{item1.description}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div v-if="type == 3" style="height: 100%">
        <!-- <div style="text-align: left;">
          <span style="margin-right: 12px">选择项目</span>
          <el-select size="small">
            <el-option></el-option>
          </el-select>
        </div> -->
        <div class="table">
           <div class="table-header">
            <p style="width: 120px;">类型</p>
            <p style="flex: 1;">红线条文</p>
            <p style="text-align: left;">引发后果</p>
            <p>类别</p>
            <p style="text-align: left;">责任岗位</p>
            <p></p>
          </div>
          <div class="table-body" v-for="(data, index) in tableData" :key="index">
            <div class="table-body-left" style="width: 120px;">{{data.typeItem}}</div>
            <div style="flex: 1">
              <div class="table-body-right" v-for="(item, index) in data.list" :key="index">
                <p class="table-body-item" style="flex: 1;">{{item.redClause}}</p>
                <p class="table-body-item">{{item.consequence}}</p>
                <p class="table-body-item" style="text-align: center;">{{item.redType}}</p>
                <p class="table-body-item">{{item.resPosition}}</p>
                <p><el-checkbox></el-checkbox></p>
              </div>
            </div>
          </div>
        </div>
        <el-button>提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        groupId: '',
        type: 1,
        priority: '',
        handleStr: '',
        apprStr: '',
        bimId: '',
        types: [],
        strPerson: [],
        description: '',
        planTree: [],
        dataTree: [],
        checkedCities: '',
        bimHouse:[
          {id:'1',label:'1栋',value:'1'},{id:'2',label:'2栋',value:'2'},{id:'3',label:'3栋',value:'3'},{id:'4',label:'4栋',value:'4'},
          {id:'5',label:'5栋',value:'5'},{id:'6',label:'6栋',value:'6'},{id:'7',label:'7栋',value:'7'},{id:'8',label:'8栋',value:'8'},
          {id:'9',label:'9栋',value:'9'},{id:'10',label:'10栋',value:'10'},{id:'11',label:'11栋',value:'11'},{id:'12',label:'12栋',value:'12'},
          {id:'13',label:'13栋',value:'13'},
        ],
        uploadphotoUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadphotoData: {
          type: '203',
        },
        fileList: [],
        label: '',
        addForm: {
          type: '',
          description: '',
          days: '',
          parentId: ''
        },
        addFormVisible: false,
        checkedCities1: [],
        checkData: [],
        isPlan: false,

        tableData: [],
        spanArr: [],
        pos: '',
        multipleSelection: [],
        redLineIds: '',

      }
    },
    created() {
      this.groupId = util.session.get('groupId')
      this.getDictByType()
      this.getPerson()
      this.getPalnList()
      this.getSaftList()
      this.getData()
    },
    methods: {
      changeType(index){
        this.type = index
      },
      // 获取问题列表
      getDictByType() {
        // getDictByType
        var that = this
        myHttp.getDictByType({
          type: 'qs_priority'
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.types = resp.data.data.dictList
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      },
      // 获取责任人列表
      getPerson() {
        var that = this;
        myHttp
          .getRoleUserList({
            groupId: this.groupId,
            userType: util.session.get('roleId')
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.strPerson = resp.data.data.users
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      submitFun() {
        var that = this
        var picUrls = []
        var that = this
        for (var i = 0; i < this.fileList.length; i++) {
          picUrls.push(this.fileList[i].response.data.saveUrls)
        }
        // console.log(picUrls.toString())
        this.picUrls = picUrls.toString()
        var form = {
          form:1,
          projectId: this.groupId,
          type: this.type,
          priority: this.priority, //问题性质
          // happenDate: this.data.date, //发生时间
          description: this.description, //问题描述
          picUrls: this.picUrls, //问题图片
          handleStr: this.handleStr, //责任人id
          apprStr: this.apprStr, //确认人id
          reportBy: util.session.get("user").id, //发起人
          qsItemId: this.qsItemId,
          planId: this.planId,
          bimId:this.bimId,
          checkType: this.checkType
        }
        // if (!form.picUrls) {
        //   this.$message.error('请上传照片')
        //   return
        // }
        // if (!form.priority) {
        //   this.$message.error('请选择问题性质')
        //   return
        // }
        // if (!form.handleStr) {
        //   this.$message.error('请选择责任人')
        //   return
        // }
        // console.log(form)
        myHttp.createInfoQs(form).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('提交成功')
              that.$router.go(-1);
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      getPalnList() {
        var that = this;
        myHttp.selectProQsPlanByProject({
          projectId: this.groupId,
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.planTree = resp.data.data.proQsPlans
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      },
      // 获取 查询安全事项列表
      getSaftList() {
        var that = this;
        myHttp.selectProQsNapeTree({
          projectId: this.groupId,
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.dataTree = resp.data.data.proQsNapes
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      },
       addPlan(item) {
       if (this.planId == item.id) {
          this.checkData = item.proQsNape
          console.log(item.id)
          this.addFormVisible = true
        }else if(this.qsItemId) {
          this.$message.warning('只能选择一项添加')
          return
        }
        else {
          this.planId = item.id
          this.checkData = item.proQsNape
          console.log(item.id)
          this.addFormVisible = true
        }
      },
      // 改变多选框值
      handleChecked(val) {
        var that = this
        console.log(this.checkedCities1)
        if(this.checkedCities1.length==0){
          this.planId = ''
        }
        that.description = ''
        that.qsItemId = ''
        var arr = []
        val.forEach((item, index) => {
          that.description += index + 1 + '.' + item.description + '    '
          arr.push(item.id)
        });
        that.qsItemId = arr.toString()
      },
      // 计划确定
      sumbitAddRow() {
        this.addFormVisible = false;  
      },
      handleChecked1(val) {
        console.log(val);
        var that = this
        console.log(this.checkedCities1)
        if(this.checkedCities1.length!=0){
          this.isPlan = true
        }else{
          this.isPlan = false
        }
        that.description = ''
        that.qsItemId = ''
        var arr = []
        val.forEach((item, index) => {
          that.description += index + 1 + '.' + item.description + '    '
          arr.push(item.id)
        });
        that.qsItemId = arr.toString()
      },
      handleIconSuccess(res, file, opt, other) {
        if (res.code == '200') {
          console.log(opt)
          console.log(res)
          this.fileList = opt
        } else {
          this.$message.error(res.msg)
        }
      },
     
     /**
      * 
      *   安全红线
      * 
                [  data
                  {    obj
                    typeItem: '安全管理',
                    list: [        dataList
                      {

                      }
                    ]
                  },
                  {
                    typeItem: '质量',
                    list: [
                      {

                      }
                    ]
                  }
                ]  
      * 
     */

    // 获取数据
    getData() {
      var that = this
      myHttp.findDetailsListPc().then(
        function(resp) {
          console.log(resp);
          if (resp.data.code == '200') {
            const list = resp.data.data.dateList || []
            if(list.length != 0){
              let data = []
              let obj = {}
              let dataList = []
              for(let i=0;i<list.length;i++){
                if(i==0){
                  obj.typeItem = list[0].typeItem
                  dataList.push(list[0])
                  obj.list=JSON.parse(JSON.stringify(dataList))
                }else{
                  if(list[i].typeItem == list[i-1].typeItem){
                    dataList.push(list[i])
                    obj.list=JSON.parse(JSON.stringify(dataList))
                  }else{
                    obj={}
                    dataList=[]
                    obj.typeItem=list[i].typeItem
                    dataList.push(list[i])
                    obj.list=JSON.parse(JSON.stringify(dataList))
                  }
                }
                data.push(JSON.parse(JSON.stringify(data.push(obj))))
              }
              console.log(data)

              let data2 = []
              for(let i=0;i<data.length;i=i+2){
                data2.push(data[i])
              }

              let newData = [...new Set(data2)]
              console.log(newData);

            }
            // that.tableData = newData
          } else {
            that.$message.error(resp.data.msg)
          }
        }
      )
    },

    },
  }
</script>

<style scoped>
.content{
  padding: 1vh 1vw;
}
.top{
  height: 56px;
  border-radius: 6px;
  background: #FFFFFF;
  text-align: left;
  padding: 16px;
  font-size: 16px;
  color: #666;
  margin-bottom: 8px;
}
.top > span {
  margin-right: 18px;
  padding-bottom: 18px;
  cursor: pointer;
}
.active{
  border-bottom: 2px solid #0D3A95;
}
.main-box{
  height: calc(100% - 64px);
  padding: 16px;
  border-radius: 6px;
  background: #fff;
  overflow: auto;
}
.content-right-4{
  display: flex;
  flex-wrap: wrap;
}
.content-right-4 > p{
  margin-bottom: 2vh;
  margin-right: 1vw;
}
.p-item {
  text-align: left;
  padding: 10px 0;
}
.ul-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 10px 20px;
}
.ul-item>li {
  width: 46%;
  height: 300px;
  border: 1px dotted #8e9092;
  overflow: auto;
}
.round_red {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #f00;
  margin-right: 10px;
}
.el-button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.table-header{
  display: flex;
  font-size: 14px;
  color: #909399;
  margin-top: 18px;
  margin-bottom: 16px;
}
.table-header > p{
  width: 80px;
}
.table-body{
  border: 1px solid #E4E7EE;
  border-bottom: none;
  display: flex;
  color: #666;
  margin-bottom: 8px;
}
.table-body-left{
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #E4E7EE;
  border-bottom: 1px solid #E4E7EE;
  width: 80px;
}
.table-body-right{
  display: flex;
  border-bottom: 1px solid #E4E7EE;
  padding: 13px 16px;
  padding-right: 0;
}
.table-body-right > p{
  width: 80px;
}
.table-body-item{
  text-align: left;
  font-size: 14px;
}
.table{
  height: calc(100% - 50px);
  overflow: auto;
  margin-bottom: 10px;
}
</style>